export type OrderCancellationCategory = "Customer" | "Driver" | "Support";

type OrderCancellationReasonCustomer =
    | "Connection issue (flight, train, ship, etc.)"
    | "Booked somewhere else"
    | "No-show"
    | "Upset with Daytrip about another trip"
    | "Price change"
    | "Flexible / super flexible cancellation"
    | "Medical"
    | "Force majeure"
    | "Other";

type OrderCancellationReasonDriver =
    | "No-show"
    | "Late pick up"
    | "Different driver sent"
    | "Different vehicle"
    | "Last minute change not accepted"
    | "Mechanical issue"
    | "Other";    

type OrderCancellationReasonSupport =
    | "Mistake"
    | "Wrong quote provided"
    | "Other";

export type ManualOrderCancellationReason =
    | OrderCancellationReasonCustomer
    | OrderCancellationReasonDriver
    | OrderCancellationReasonSupport;

const CANCELLATION_CATEGORIES = ["Customer", "Driver", "Support"] as const;
export const ORDER_CANCELLATION_CATEGORIES =
    CANCELLATION_CATEGORIES as readonly OrderCancellationCategory[];
export const ORDER_CANCELLATION_REASONS: {
    [Key in OrderCancellationCategory]: ManualOrderCancellationReason[];
} = {
    Customer: [
        "Connection issue (flight, train, ship, etc.)",
        "Booked somewhere else",
        "No-show",
        "Upset with Daytrip about another trip",
        "Price change",
        "Flexible / super flexible cancellation",
        "Medical",
        "Force majeure",
        "Other",
    ],
    Driver: [
        "No-show",
        "Late pick up",
        "Different driver sent",
        "Different vehicle",
        "Last minute change not accepted",
        "Mechanical issue",
        "Other", 
    ],
    Support: [
        "Mistake",
        "Wrong quote provided",
        "Other",
    ],
};

type OrderCancellationReason = ManualOrderCancellationReason;

export type OrderCancellationInfo = {
    category: OrderCancellationCategory;
    reason: OrderCancellationReason;
    note?: string;
};

export const CANCELED_BY_CUSTOMER_CANCELLATION_INFO: OrderCancellationInfo = {
    category: "Customer",
    reason: "Other",
    note: "Cancelled by the customer via the customer interface",
};
export const CANCELED_BY_PARTNER_API_CANCELLATION_INFO: OrderCancellationInfo = {
    category: "Customer",
    reason: "Other",
    note: "Cancelled by the customer via the partner API",
};

export const orderCancellationInfoToString = (info: OrderCancellationInfo): string => {
    return `${info.category}: ${info.reason}`;
};
